import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export function QMenuPage() {
  return (
    <section className="qr-mobile q-landing-shell">
      <Seo title="타로맨스 | Q Menu" description="QR 전용 메뉴 진입 페이지" />
      <article className="card q-landing-card">
        <p className="eyebrow">Q Menu</p>
        <h1>메뉴를 바로 확인하세요.</h1>
        <p>QR 전용 경량 진입 페이지입니다. 바로 메뉴 화면으로 이동할 수 있게 최소 구조로 구성했습니다.</p>
        <Link className="btn active" to="/qr">QR 메뉴 열기</Link>
      </article>
    </section>
  );
}
